app.directive('bedragInput', [function() {
	return {
		require: 'ngModel',
		link: function($scope, element, attrs, modelCtrl) {

			function constraintInput(value) {
				return (value+'').replace(/[^\d\.\,]/g, '');
			}

			function parseInput(value) {
				return parseFloat( (value+'').replace(/[^\d\.\,]/g, '').replace(/\./g, '').replace(/\,/g, '.') ) || 0;
			}

			function formatValue(value) {
				if (value === undefined || value === '') return '';
				return number_format(value, attrs.uiNumber, ',', '.');
			}

			function formatter(value) {
				return formatValue( parseFloat(value) || undefined );
			}

			function parser(value) {

				var cleanValue = constraintInput(value);

				if (value !== undefined && value !== cleanValue) {
					modelCtrl.$setViewValue(cleanValue);
					modelCtrl.$render();
				}

				return parseInput(value);
			}

			modelCtrl.$parsers.push(parser);
			modelCtrl.$formatters.push(formatter);

			element.on('click', function() {
				element.select();
			});

			element.on('blur', function() {
				$scope.$apply(function() {

					if (modelCtrl.$modelValue) {
						modelCtrl.$setViewValue( formatValue(modelCtrl.$modelValue) );
						modelCtrl.$render();
					}

				});
			});
		}
	};

	function number_format(number, decimals, dec_point, thousands_sep) {
	    dec_point = typeof dec_point !== 'undefined' ? dec_point : '.';
	    thousands_sep = typeof thousands_sep !== 'undefined' ? thousands_sep : ',';

	    var parts = parseFloat(number).toFixed(decimals).split('.');
	    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);

	    return parts.join(dec_point);
	}
}]);